















import { Vue, Component, Watch } from "vue-property-decorator";
import * as AuthStore from "./store/modules/auth";
import Snack from "./components/Snack.vue";
import Layout from "./components/Layout.vue";

@Component({
  components: {
    Snack,
    Layout
  }
})
export default class App extends Vue {
  get isAuthenticated() {
    return AuthStore.getters.isAuthenticated;
  }

  @Watch("isAuthenticated", { immediate: true })
  authChangeHandler() {
    if (!this.isAuthenticated && this.$route.path !== "/login") {
      this.$router.push("/login");
    } else if (this.isAuthenticated && this.$route.path === "/login") {
      this.$router.push("/");
    }
  }

  created() {
    AuthStore.mutations.loadUserFromLS();
  }
}
